export default "__VITE_ASSET__4d6ccdc6__"